/** import custom dependency [start] */
import { getData } from '../';
import URL from '../../utils/baseUrls';
/** import custom dependency [end] */

/**
 * Get the Workspace list form the backend
 * @returns
 */
export const getWorkspaceListData = async () => {
    const res = await getData(URL.getWorkspaceListUrl());
    return res;
};

export const getUserDetails = async () => {
    const res = await getData(URL.getUserInfo());
    return res;
};
